import { Readable } from 'interfaces/readable';

interface IRGBColor {
  red: number;
  green: number;
  blue: number;
}

export default class RGBColor implements Readable {
  private readonly red: number;
  private readonly green: number;
  private readonly blue: number;

  constructor(props: IRGBColor) {
    this.red = props.red;
    this.green = props.green;
    this.blue = props.blue;
  }

  toString() {
    return `${this.red}, ${this.green}, ${this.blue}`;
  }
}
